import React from 'react'
import { useFieldArray } from 'react-hook-form'

import type { FormFieldArrayProps } from './type'

export const FormFieldArray = <
  TFieldArrayValues extends Record<string, unknown> = Record<string, unknown>
>({
  name,
  control,
  children,
}: FormFieldArrayProps<TFieldArrayValues>) => {
  const methods = useFieldArray({ name, control })
  return <>{children(methods)}</>
}
